import React from 'react';
import * as Yup from 'yup';
import Form from '@dashboard/components/Formik/Form';
import Button from '@dashboard/components/Button';

export const validationSchema = Yup.object().shape({
  displayName: Yup.string()
    .required('Tax name is required')
    .max(50, 'Tax name must be 50 characters or less'),
  percentage: Yup.number()
    .typeError('Enter a number')
    .moreThan(0, 'Must be greater than 0')
    .lessThan(101, 'Must be less than or equal to 100')
    .required('Tax rate is required'),
});

const TAX_BEHAVIOR_OPTIONS = [
  { value: 'exclusive', label: 'Exclusive', helpText: 'Tax is added on top of the price.' },
  { value: 'inclusive', label: 'Inclusive', helpText: 'Tax is included in the price.' },
];

const getFields = inline => [
  ...(inline
    ? [
        {
          type: 'columns',
          columns: 2,
          isDesignForm: false,
          fields: [
            {
              type: 'text',
              name: 'displayName',
              label: 'Tax name',
              placeholder: 'VAT, Sales Tax, GST',
            },
            {
              type: 'number',
              name: 'percentage',
              label: 'Tax rate (%)',
              placeholder: '0',
              step: '0.01',
            },
          ],
        },
      ]
    : [
        {
          type: 'text',
          name: 'displayName',
          label: 'Tax name',
          placeholder: 'VAT, Sales Tax, GST',
        },
        {
          type: 'number',
          name: 'percentage',
          label: 'Tax rate (%)',
          placeholder: '0',
          step: '0.01',
        },
      ]),
  {
    type: 'radio',
    name: 'taxBehavior',
    label: 'Tax behavior',
    options: TAX_BEHAVIOR_OPTIONS,
  },
  { type: 'divider' },
  {
    type: 'checkbox',
    name: 'default',
    label: 'Set as default tax rate',
    helpText: 'Used by default when selecting a tax rate.',
  },
];

const CreateTaxRateForm = ({ onSubmit, isPending, inline = false }) => (
  <Form
    initialValues={{ displayName: '', percentage: '', taxBehavior: 'exclusive', default: false }}
    validationSchema={validationSchema}
    fields={getFields(inline)}
    onSubmit={async (values, actions) => {
      try {
        await onSubmit(
          {
            displayName: values.displayName,
            inclusive: values.taxBehavior === 'inclusive',
            percentage: Number(values.percentage),
            default: values.default,
          },
          { resetForm: () => actions.resetForm() },
        );
        return { data: true };
      } catch (error) {
        return { error };
      }
    }}
    formSubmit={() => (
      <div className={inline ? 'mt-2' : 'flex justify-end mt-6'}>
        <Button appearance="primary" type="submit" disabled={isPending}>
          Save
        </Button>
      </div>
    )}
  />
);

export default CreateTaxRateForm;
